import DeepLink from 'apps/auth/components/DeepLink';
import EmailRedirect from 'apps/auth/components/email/EmailRedirect';
import { NO_AUTH_VIEW } from 'apps/auth/constants/ServerConstants';

const deepLinkAuth = [
    {
        path: '/dl',
        component: DeepLink,
        view: NO_AUTH_VIEW,
    },
    {
        path: '/dl/onfido',
        component: DeepLink,
        view: NO_AUTH_VIEW,
    },
    {
        path: '/dl/email_confirm_redirect',
        component: EmailRedirect,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        isPathWithoutFooter: false,
        stateOptions: {
            registrationFlow: true,
            openChatInNoAuthZone: true,
            introPage: true,
            showChat: true,
        },
        useSingleRoute: true,
    },
    {
        path: '/dl/:wildcard',
        component: DeepLink,
        view: NO_AUTH_VIEW,
    },
];
export default deepLinkAuth;
